import HomePage from '../pages/homePage/HomePage'
import QuestionContainer from '../pages/questionPage/QuestionContainer'
import RulesPage from '../pages/rulesPage/RulesPage'
import UserPage from '../pages/userPage/UserPage'

export const routes = [
  {
    name: 'Rule',
    path: 'rules/:id',
    element: <RulesPage />,
    icon: 'rule',
    layout: 'blank',
  },
  {
    name: 'Home Page',
    path: 'home',
    element: <HomePage />,
    icon: 'home',
    layout: 'home',
  },
  {
    name: 'User',
    path: 'user',
    element: <UserPage />,
    icon: 'user',
    layout: 'home',
  },
  {
    name: 'Question',
    path: 'question/:id',
    element: <QuestionContainer />,
    icon: 'user',
    layout: 'blank',
  },
]
